/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type PatientBasicsDtoCaseType = (typeof PatientBasicsDtoCaseType)[keyof typeof PatientBasicsDtoCaseType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientBasicsDtoCaseType = {
  INDEX: 'INDEX',
  TRACING_CONTACT: 'TRACING_CONTACT',
  SCREENING_INDIVIDUAL: 'SCREENING_INDIVIDUAL',
} as const;
